<div class="db-account-settings-wrapper">
  <div class="db-account-settings__header">
    <div>
      <h3>{{'text_personalInformation' | dbText}}</h3>
      <a id="save" class="{{isMobile ? 'ds-btn-s' : 'ds-btn-m'}} ds-btn-blue" (click)="onAccountUpdate()"
         [ngClass]="{'disabled': loading}">
        <span *ngIf="!loading">{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
  <form class="db-account-settings" [formGroup]="accountSettings" (ngSubmit)="onAccountUpdate()">
    <div class="db-account-settings__settings-wrap">
      <div class="db-account-settings__avatar">
        <div class="db-account-settings__avatar-picture">
          <a href='https://en.gravatar.com/' target='_blank' rel="noopener">
            <img dbGravatar [email]="accountSettings.controls['email'].value" size="100" src="" alt=""/></a>
        </div>
        <div><a class="db-account-settings__item-desc" href='https://en.gravatar.com/' target="_blank">{{ 'text_editAt' | dbText }}
          Gravatar.com <i class="db-icon db-icon-external-n"></i></a></div>
      </div>
      <div class="db-account-settings__settings-grid">
        <div>
          <div class="db-account-settings__label">
            <label for="name">{{'text_accountSettingsFirstName' | dbText}}</label>
          </div>
          <input class="db-fc-input db-account-settings__input" type="text" name="name" id="name"
                 formControlName="firstName"
                 x-autocompletetype="name" maxlength="60"
                 [style.border-color]="(accountSettings.controls['firstName'].invalid && accountSettings.controls['firstName'].touched) || accountSettings.controls['firstName'].value === '' || serverErrors?.fields?.first_name ? '#E95E5B' : null">
          <div class="db-account-invalid-note"
               *ngIf="(accountSettings.controls['firstName'].invalid && accountSettings.controls['firstName'].touched) || accountSettings.controls['firstName'].value === '' || serverErrors?.fields?.first_name">{{serverErrors?.fields?.first_name ? serverErrors?.fields?.first_name : (accountSettings.controls['firstName'].errors?.link ? ('text_invalidFirstName' | dbText) : ('text_fillFnField' | dbText))}}</div>
        </div>
        <div>
          <div class="db-account-settings__label">
            <label for="lastName">{{'text_accountSettingsLastName' | dbText}}</label>
          </div>
          <input class="db-fc-input db-account-settings__input" type="text" name="lastName" id="lastName"
                 formControlName="lastName"
                 x-autocompletetype="lastName" maxlength="60"
                 [style.border-color]="(accountSettings.controls['lastName'].invalid && accountSettings.controls['lastName'].touched) || accountSettings.controls['lastName'].value === '' || serverErrors?.fields?.last_name? '#E95E5B' : null">
          <div class="db-account-invalid-note"
               *ngIf="(accountSettings.controls['lastName'].invalid && accountSettings.controls['lastName'].touched) || accountSettings.controls['lastName'].value === '' || serverErrors?.fields?.last_name">{{serverErrors?.fields?.last_name ? serverErrors?.fields?.last_name : (accountSettings.controls['lastName'].errors?.link ? ('text_invalidLastName' | dbText) : ('text_fillFnField' | dbText))}}</div>
        </div>
        <div>
          <div class="db-account-settings__label">
            <label for="phone_number">{{'text_phoneNumber' | dbText}}</label>
          </div>
          <input class="db-fc-input db-account-settings__input" placeholder="+123 55 555 555" type="tel" name="phone"
                 id="phone_number"
                 formControlName="phoneNumber" x-autocompletetype="tel">
          <div class="db-account-invalid-note"
               *ngIf="accountSettings.controls['phoneNumber'].invalid && accountSettings.controls['phoneNumber'].touched">{{'text_invalidPhoneNumber' | dbText}}</div>
        </div>
        <div>
          <div class="db-account-settings__label">
            <label for="company_website">{{'text_website' | dbText}}</label>
          </div>
          <input class="db-fc-input db-account-settings__input" placeholder="http://www.example.com" type="text"
                 name="company_website"
                 id="company_website" formControlName="companyWebsite">
          <div class="db-account-invalid-note"
               *ngIf="accountSettings.controls['companyWebsite'].invalid && accountSettings.controls['companyWebsite'].touched">{{'text_fillWebsiteField' | dbText}}</div>
        </div>
      </div>
    </div>
    <div class="db-account-settings__settings-wrap db-account-settings__timezone">
      <div>
        <div class="db-account-settings__item-title" [innerHTML]="'text_localTimeZone' | dbText"></div>
        <div class="db-account-settings__item-desc">{{ 'text_yourDashboardWillDisplayYourLocalTime' | dbText }}</div>
      </div>
      <div>
        <div class="db-account-settings__label">
          <label>{{'text_timeZone' | dbText}}</label>
        </div>
        <db-fc-dropdown-select class="db-fc-input db-account-settings__select" formControlName="timeZone"
                               [value]="accountSettings.controls['timeZone'].value"
                               [options]="timeZoneOptions"></db-fc-dropdown-select>
      </div>
    </div>
  </form>
</div>

